//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required;

export default {
  data: function data() {
    return {
      labelright: null,
      topcenter: null,
      topleft: null,
      topright: null,
      bottomcenter: null,
      bottomleft: null,
      bottomright: null,
      errorl_0: null,
      errorl_25: null,
      errorl_50: null,
      errorl_75: null,
      errorl_100: null,
      errorl_125: null,
      errorl_150: null,
      errorl_175: null,
      errorl_200: null,
      errorl_225: null,
      errorl_250: null,
      errorl_275: null
    };
  },
  mixins: [validationMixin],
  validations: {
    labelright: {
      required: required
    },
    topcenter: {
      required: required
    },
    topleft: {
      required: required
    },
    topright: {
      required: required
    },
    bottomcenter: {
      required: required
    },
    bottomleft: {
      required: required
    },
    bottomright: {
      required: required
    },
    errorl_0: {
      required: required
    },
    errorl_25: {
      required: required
    },
    errorl_50: {
      required: required
    },
    errorl_75: {
      required: required
    },
    errorl_100: {
      required: required
    },
    errorl_125: {
      required: required
    },
    errorl_150: {
      required: required
    },
    errorl_175: {
      required: required
    },
    errorl_200: {
      required: required
    },
    errorl_225: {
      required: required
    },
    errorl_250: {
      required: required
    },
    errorl_275: {
      required: required
    }
  },
  methods: {
    onValitadeFormSubmit: function onValitadeFormSubmit() {
      this.$v.$touch();
      console.log("ok");
    }
  }
};